
import { Component } from "vue-property-decorator";
import OverviewCellBase from "@/app/dynamic-components/overviews/cells/overview-cell.base";
import { ExchangeDefinition } from "@/app/dynamic-components/details/dynamic-detail.model";

@Component({
  components: {},
})
export default class OverviewCellExchangeAction extends OverviewCellBase {
  mounted(): void {
    const i = 0;
  }

  getCurrentStepTitle(stepId: string) {
    if (!this.additionalMetadata) return 1;
    const exchangeDefinition: ExchangeDefinition = this.additionalMetadata
      ?.definition as ExchangeDefinition;

    const indexOfExhangeStep = exchangeDefinition.steps.findIndex(
      (value) => value.id === stepId
    );

    if (indexOfExhangeStep < 0) return "-";

    return exchangeDefinition.steps[indexOfExhangeStep].action;
  }
}
